export const DISCORD_INVITE = "https://discord.gg/3Y99DeVte2"
